// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/booking/activity/activity_booking.proto (package carmen, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_proto_model_entity_place } from "../../entity/place_pb";
import { file_proto_model_booking_activity_participant_info } from "./participant_info_pb";
import { file_proto_model_booking_shared_provider_booking_details } from "../shared/provider_booking_details_pb";
import { file_proto_model_financial_budget } from "../../financial/budget_pb";

/**
 * Describes the file proto/model/booking/activity/activity_booking.proto.
 */
export const file_proto_model_booking_activity_activity_booking = /*@__PURE__*/
  fileDesc("CjNwcm90by9tb2RlbC9ib29raW5nL2FjdGl2aXR5L2FjdGl2aXR5X2Jvb2tpbmcucHJvdG8SBmNhcm1lbiKUAgoPQWN0aXZpdHlCb29raW5nEigKEWFjdGl2aXR5X2xvY2F0aW9uGAEgASgLMg0uY2FybWVuLlBsYWNlEhkKEWFjdGl2aXR5X29mZmVyX2lkGAIgASgJEi0KDHBhcnRpY2lwYW50cxgDIAMoCzIXLmNhcm1lbi5QYXJ0aWNpcGFudEluZm8SGAoQc3BlY2lhbF9yZXF1ZXN0cxgEIAMoCRI4ChBwcm92aWRlcl9kZXRhaWxzGAUgASgLMh4uY2FybWVuLlByb3ZpZGVyQm9va2luZ0RldGFpbHMSOQoRYnVkZ2V0X3ZhbGlkYXRpb24YBiABKAsyHi5jYXJtZW4uQnVkZ2V0VmFsaWRhdGlvblJlc3VsdEIwWi5naXRodWIuY29tL3l1bmFjYWJhL2Nhcm1lbi9wcm90by9tb2RlbC9ib29raW5nYgZwcm90bzM", [file_proto_model_entity_place, file_proto_model_booking_activity_participant_info, file_proto_model_booking_shared_provider_booking_details, file_proto_model_financial_budget]);

/**
 * Describes the message carmen.ActivityBooking.
 * Use `create(ActivityBookingSchema)` to create a new message.
 */
export const ActivityBookingSchema = /*@__PURE__*/
  messageDesc(file_proto_model_booking_activity_activity_booking, 0);

